export default function (http) {
    return {
        querySaleAudit(data) {
            return http.json({
                url: `/finance/querySaleAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        terminate(data){
            return http.json({
                url: `/finance/terminate`,
                data
            });
        },
        queryAfterSaleAudit(data) {
            return http.json({
                url: `/finance/queryAfterSaleAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryOtherSaleAudit(data) {
            return http.json({
                url: `/finance/queryOtherSaleAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryDepositAudit(data) {
            return http.json({
                url: `/finance/queryDepositAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryReport(data) {
            return http.json({
                url: `/finance/queryReport?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryJiNanReport(data) {
            return http.json({
                url: `/finance/queryJiNanReport?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryBuyReport(){
            return http.json({
                url: `/finance/queryBuyReport?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryHH(data) {
            return http.json({
                url: `/finance/queryHH?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryOut(data) {
            return http.json({
                url: `/finance/queryOut?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryBuyAudit(data) {
            return http.json({
                url: `/finance/queryBuyAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryOtherBuyAudit(data) {
            return http.json({
                url: `/finance/queryOtherBuyAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryBuyReturnAudit(data) {
            return http.json({
                url: `/finance/queryBuyReturnAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryDiaoboAudit(data) {
            return http.json({
                url: `/finance/queryDiaoboAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryGuangDongDiaoboAudit(data) {
            return http.json({
                url: `/finance/queryGuangDongDiaoboAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },



        queryElectronicAudit(data) {
            return http.json({
                url: `/finance/queryElectronicAudit?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/finance/getDeatil?code=${data.id}`,
                data
            })
        },

        queryUserPoint(data) {
            return http.json({
                url: `/sys/point/queryUserPoint`,
                data
            });
        },

        queryUserPointByCode(data) {
            return http.json({
                url: `/sys/point/queryUserPointByCode`,
                data
            });
        },

        queryTotalPoint(data) {
            return http.json({
                url: `/sys/point/queryTotalPoint`,
                data
            });
        },

        queryAllUserPointByPage(data){
            return http.json({
                url: `/sys/point/queryAllUserPointByPage`,
                data
            })
        },

        queryJnCjxByWareHouse(data){
            return http.json({
                url: `/finance/queryJnCjxByWareHouse`,
                data
            })
        },

        queryCjxByWareHouse(data){
            return http.json({
                url: `/finance/queryCjxByWareHouse`,
                data
            })
        },
        queryJnCjxByWareHouseByOrderItem(data){
            return http.json({
                url: `/finance/queryJnCjxByWareHouseByOrderItem`,
                data
            })
        },

        queryCjxByWareHouseByOrderItem(data){
            return http.json({
                url: `/finance/queryCjxByWareHouseByOrderItem`,
                data
            })
        },




    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/finance.js